<template>
    <div class="tile-content">
        <div class="tile-subtitle">
            <h3>Card Statement Descriptor</h3>
        </div>
        <p class="stack-m">Most gateway accounts have a static or default descriptor. The descriptor is what appears on
            the cardholder's monthly statement. Some gateway accounts allow for dynamic descriptors
            (eg., <code>Reb*Pioneer Plan</code>).</p>
        <p class="stack-m">Entry of a static descriptor here is purely informational and
            useful in reporting, and chargeback representations.</p>
        <div class="grid-content">
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Descriptor"
                    :value="descriptor"
                    :disabled="dynamicDescriptor"
                    @input="updateDescriptor"/>
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="City"
                    :value="cityField"
                    :disabled="dynamicDescriptor"
                    @input="updateCityField"/>
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-checkbox
                    label="Dynamic Descriptor"
                    :value="true"
                    :selected="dynamicDescriptor"
                    caption="When enabled the descriptor will be generated automatically by Rebilly."
                    @input="updateDynamicDescriptor"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'card-statement-descriptor',
        props: {
            descriptor: {
                type: String,
            },
            cityField: {
                type: String,
            },
            dynamicDescriptor: {
                type: Boolean,
            },
        },
        methods: {
            getPayload({descriptor, cityField, dynamicDescriptor}) {
                const payload = {
                    descriptor: this.descriptor,
                    cityField: this.cityField,
                    dynamicDescriptor: this.dynamicDescriptor,
                };
                if (descriptor) {
                    payload.descriptor = descriptor;
                }
                if (cityField) {
                    payload.cityField = cityField;
                }
                if (dynamicDescriptor !== undefined) {
                    payload.dynamicDescriptor = dynamicDescriptor;
                }
                return payload;
            },
            updateDescriptor(value) {
                this.$emit('input', this.getPayload({descriptor: value}));
            },
            updateCityField(value) {
                this.$emit('input', this.getPayload({cityField: value}));
            },
            updateDynamicDescriptor(value) {
                this.$emit('input', this.getPayload({dynamicDescriptor: value}));
            },
        },
    };
</script>
